/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserBillingAccountDto
 */
export interface UserBillingAccountDto {
    /**
     *
     * @type {number}
     * @memberof UserBillingAccountDto
     */
    userBillingAccountId?: number;
    /**
     *
     * @type {number}
     * @memberof UserBillingAccountDto
     */
    userAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof UserBillingAccountDto
     */
    providerUserId?: string;
    /**
     *
     * @type {string}
     * @memberof UserBillingAccountDto
     */
    provider?: UserBillingAccountDtoProviderEnum;
    /**
     *
     * @type {string}
     * @memberof UserBillingAccountDto
     */
    currencyCode?: string;
    /**
     *
     * @type {string}
     * @memberof UserBillingAccountDto
     */
    status?: UserBillingAccountDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof UserBillingAccountDto
     */
    statusMessage?: string;
    /**
     *
     * @type {Date}
     * @memberof UserBillingAccountDto
     */
    termsAcceptedAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof UserBillingAccountDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const UserBillingAccountDtoProviderEnum = {
    Unknown: "Unknown",
    StripeSandbox: "StripeSandbox",
    Stripe: "Stripe",
} as const;
export type UserBillingAccountDtoProviderEnum =
    (typeof UserBillingAccountDtoProviderEnum)[keyof typeof UserBillingAccountDtoProviderEnum];

/**
 * @export
 */
export const UserBillingAccountDtoStatusEnum = {
    Unknown: "Unknown",
    Required: "Required",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;
export type UserBillingAccountDtoStatusEnum =
    (typeof UserBillingAccountDtoStatusEnum)[keyof typeof UserBillingAccountDtoStatusEnum];

/**
 * Check if a given object implements the UserBillingAccountDto interface.
 */
export function instanceOfUserBillingAccountDto(
    value: object,
): value is UserBillingAccountDto {
    return true;
}

export function UserBillingAccountDtoFromJSON(
    json: any,
): UserBillingAccountDto {
    return UserBillingAccountDtoFromJSONTyped(json, false);
}

export function UserBillingAccountDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserBillingAccountDto {
    if (json == null) {
        return json;
    }
    return {
        userBillingAccountId:
            json["userBillingAccountId"] == null
                ? undefined
                : json["userBillingAccountId"],
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        providerUserId:
            json["providerUserId"] == null ? undefined : json["providerUserId"],
        provider: json["provider"] == null ? undefined : json["provider"],
        currencyCode:
            json["currencyCode"] == null ? undefined : json["currencyCode"],
        status: json["status"] == null ? undefined : json["status"],
        statusMessage:
            json["statusMessage"] == null ? undefined : json["statusMessage"],
        termsAcceptedAt:
            json["termsAcceptedAt"] == null
                ? undefined
                : new Date(json["termsAcceptedAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function UserBillingAccountDtoToJSON(
    value?: UserBillingAccountDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        userBillingAccountId: value["userBillingAccountId"],
        userAccountId: value["userAccountId"],
        providerUserId: value["providerUserId"],
        provider: value["provider"],
        currencyCode: value["currencyCode"],
        status: value["status"],
        statusMessage: value["statusMessage"],
        termsAcceptedAt:
            value["termsAcceptedAt"] == null
                ? undefined
                : value["termsAcceptedAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
